import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';

export class GaugeChartData {
  percentage: number;
  subText: string;
}

@Component({
    selector: 'gauge-chart',
    templateUrl: './gauge-chart.component.html',
    styleUrls: ['./gauge-chart.component.css'],
    standalone: false
})
export class GaugeChartComponent implements OnInit {
  @ViewChild('progress', {static: false}) progress: ElementRef;
  @Input() data: GaugeChartData;

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      this.calculateScorePercentages();
    }, 100);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.calculateScorePercentages();
    }, 100);
  }

  private calculateScorePercentages(): void {
    var value = this.data.percentage;

    let item: HTMLCollection = this.progress.nativeElement;
    var left = $(item).find('.progress-left .progress-bar');
    var right = $(item).find('.progress-right .progress-bar');

    if (value > 0) {
      if (value <= 50) {
        var valuePercentage = value / 100 * 360;
        right.css('transform', 'rotate(' + valuePercentage + 'deg)')
      } else {
        var valuePercentage = (value - 50) / 100 * 360;
        right.css('transform', 'rotate(180deg)')
        left.css('transform', 'rotate(' + valuePercentage + 'deg)')
      }
    }
  }

}
